<template>
    <auth-reg-window :show-client-login-option="false" />
</template>

<script>
import AuthRegWindow from '@/components/AuthReg/AuthRegWindow'

export default {
    components: {
        AuthRegWindow
    },
    mounted() {
        
    }
}
</script>
